"use strict";
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SELECT_MATCH_TARGET_WIDTH = exports.SELECT_POPOVER = exports.SELECT = exports.OMNIBAR_OVERLAY = exports.OMNIBAR = exports.MULTISELECT_TAG_INPUT_INPUT = exports.MULTISELECT_POPOVER = exports.MULTISELECT = void 0;
var core_1 = require("@blueprintjs/core");
var NS = core_1.Classes.getClassNamespace();
exports.MULTISELECT = NS + "-multi-select";
exports.MULTISELECT_POPOVER = exports.MULTISELECT + "-popover";
exports.MULTISELECT_TAG_INPUT_INPUT = exports.MULTISELECT + "-tag-input-input";
exports.OMNIBAR = NS + "-omnibar";
exports.OMNIBAR_OVERLAY = exports.OMNIBAR + "-overlay";
exports.SELECT = NS + "-select";
exports.SELECT_POPOVER = exports.SELECT + "-popover";
exports.SELECT_MATCH_TARGET_WIDTH = exports.SELECT + "-match-target-width";
//# sourceMappingURL=classes.js.map